import { z } from "zod";

import { CommonModels } from "@/data/common/common.models";

export namespace BizTagsModels {
  /**
   * CreateBizTagDtoSchema
   * @type { object }
   * @property { string } name
   */
  export const CreateBizTagDtoSchema = z.object({ name: z.string() });
  export type CreateBizTagDto = z.infer<typeof CreateBizTagDtoSchema>;

  /**
   * UpdateBizTagDtoSchema
   * @type { object }
   * @property { string } name
   */
  export const UpdateBizTagDtoSchema = z.object({ name: z.string() });
  export type UpdateBizTagDto = z.infer<typeof UpdateBizTagDtoSchema>;

  /**
   * ListTagsResponseSchema
   * @type { object }
   * @property { object[] } order List of order definitions
   * @property { number } page 1-indexed page number to begin from
   * @property { string } cursor ID of item to start after
   * @property { string } nextCursor Cursor for next set of items
   * @property { number } limit Items per response
   * @property { number } totalItems Total available items
   * @property { CommonModels.BizTagDto[] } items
   */
  export const ListTagsResponseSchema = CommonModels.PaginationDtoSchema.merge(
    z.object({ items: z.array(CommonModels.BizTagDtoSchema) }).partial(),
  );
  export type ListTagsResponse = z.infer<typeof ListTagsResponseSchema>;
}
